/**
 * Dashboard Table Component
 *
 * One row per employee (GET /api/employees/dashboard-list): sent, draft, submitted,
 * resubmission_requested, resubmitted — current progress, no duplicate names.
 */
import React from 'react';
import './DashboardTable.css';

/** Lowercase AccountStatus from API */
export type DashboardTableStatus =
  | 'registered'
  | 'sent'
  | 'draft'
  | 'submitted'
  | 'resubmission_requested'
  | 'resubmitted'
  | 'cleared';

export interface TableRow {
  id: string;
  name: string;
  notificationSentDate: string;
  status: DashboardTableStatus | string;
  statusUpdateDate: string;
  statusUpdateTime: string;
}

export interface DashboardTableProps {
  /** Rows from GET /api/employees/dashboard-list */
  data?: TableRow[];
}

const DashboardTable: React.FC<DashboardTableProps> = ({ data = [] }) => {
  const displayData = data;

  const getStatusLabel = (status: string) => {
    switch (status) {
      case 'sent':
        return '未着手';
      case 'draft':
        return '進行中';
      case 'submitted':
        return '完了';
      case 'resubmission_requested':
        return '再提出依頼中';
      case 'resubmitted':
        return '再提出済み';
      case 'cleared':
        return '審査完了';
      case 'registered':
        return '未招待';
      default:
        return status || '—';
    }
  };

  return (
    <div className="dashboard-table">
      <div className="dashboard-table__container">
        <table className="dashboard-table__table">
          <thead>
            <tr>
              <th>氏名</th>
              <th>通知送信日</th>
              <th>ステータス</th>
              <th>ステータス更新日</th>
              <th>ステータス更新時刻</th>
            </tr>
          </thead>
          <tbody>
            {displayData.map((row) => (
              <tr key={row.id}>
                <td>{row.name}</td>
                <td>{row.notificationSentDate}</td>
                <td>{getStatusLabel(row.status)}</td>
                <td>{row.statusUpdateDate}</td>
                <td>{row.statusUpdateTime}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DashboardTable;
